import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { FundReturnRetrivalModalComponent } from '../fund-return-retrival-modal/fund-return-retrival-modal.component';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import * as $ from 'jquery';
import { UserService } from '../../../../services/user.service';
import { CommonService } from '../../../../services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fund-request-modal',
  templateUrl: './fund-request-modal.component.html',
  styleUrls: ['./fund-request-modal.component.scss']
})
export class FundRequestModalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  content: any;
  heading: string;
  PermissionAttach: string;
  action: Subject<any> = new Subject();
  fundRequestForm: UntypedFormGroup;
  columnDefs;
  context;
  gridApi: GridApi;
  rowData;
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  categoryOptions = [];
  subCategoryOptions = [];
  AllsubCategoryOptions = [];
  public StatusStr = "";
  bankDetailsOptions = [];
  ApplicationID: any;
  userType: any;
  billingAddress: any;
  //DefaultBankAddress: any;
  RetrivalLabel: any;
  CurrancySymbal: any = "";
  loadGrid = false;
  gridOptions;
  selectedRow: any;
  frameworkComponents;
  operations: any[] = [];
  TempOperations: { name: string; id: string; }[];
  returnAmount: string;
  usFund: string;
  returnVia: string;
  currency: string;
  RequiredSettings: boolean = true;
  currencyCode: string;
  currencySymbol: any;
  orgCurrency: string;
  orgSymbol: string;
  returnFund: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  staticformFields: any;
  genInfoFieldControls: any[] = [];
  Application_Type_ID: any = null;
  Currency_ID: string = "";
  Currenct_Currency_Symbol: string = "";
  Target_Currency_Symbol: string = "";
  CONVERSION_RATE: number = 0;
  RequestedAmount_Target_Convert: number = 0;
  AllocatedAmount_Target_Convert: number = 0;
  returnAmount_Target_Convert: number = 0;
  consumedAmount_Target_Convert: number = 0;
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    private commonService: CommonService
  ) { }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.datashareService.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
    if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.datashareService.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      if (!this.ApplicationID) {
        this.GetIstGenInfoScreenConfigControls();
      }
    });


    this.getStaticFiledsData('SCR-007');
    this.rowData = [];
    this.returnAmount = this.Content.content.ReturnAmount;
    this.returnFund = this.Content.content.ReturnFund;
    this.usFund = this.Content.content.UsedFund;
    this.returnVia = this.Content.content.RetrieveVia;


    if (this.Content.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }

    this.userType = this.userService.getUserType();

    this.fundRequestForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      Application_ID: new UntypedFormControl(null),
      Category: new UntypedFormControl(null),
      SubCategory: new UntypedFormControl(null),
      OtherCattegory: new UntypedFormControl(null),
      RequiredFoud: new UntypedFormControl(null),
      UsedFund: new UntypedFormControl(null),
      BankDetailsID: new UntypedFormControl(null),
      IsCheckNumber: new UntypedFormControl(""),
      IsTransfertoBank: new UntypedFormControl(""),
      ReturnAmount: new UntypedFormControl(this.returnAmount),
      CheckNumber: new UntypedFormControl(null),
      ShipmentServiceProvider: new UntypedFormControl(null),
      ShipmentTracingNumber: new UntypedFormControl(null),
      StatusStr: new UntypedFormControl(null),
      AllocatedFund: new UntypedFormControl(null),
      TransactionNumber: new UntypedFormControl(null),
      ReturnTransactionNumber: new UntypedFormControl(null),
      Status: new UntypedFormControl(0),
      CurrencyCode: new UntypedFormControl(this.currencyCode)
    });

    this.fundRequestForm.controls['CurrencyCode'].disable();
    this.getMasterData();

    if (this.Content.heading === 'Edit' || this.Content.heading === 'View'
      || this.Content.heading == 'Allocate' || this.Content.heading == 'Return') {
      this.getFundEdit();
    }
    else {
      this.StatusStr = "Draft";
      document.body.click();
    }

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
      }
    }

    this.TempOperations = [];

    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      }, {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ];

    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
      }
    }

  
   this.fundRequestForm.controls['AllocatedFund']?.valueChanges.subscribe(value => {  
    if(this.userType=="I"){
     const amount = Number(value);
     const qty = Number(this.CONVERSION_RATE);
     this.AllocatedAmount_Target_Convert =Number((amount * qty).toFixed(2));
    }
  
  });
   this.fundRequestForm.controls['UsedFund']?.valueChanges.subscribe(value => {
     if(this.userType=="E"){
      const amount = Number(value);
      const qty = Number(this.CONVERSION_RATE);
        this.consumedAmount_Target_Convert = Number((amount * qty).toFixed(2));
     }
    
  });
  this.fundRequestForm.controls['ReturnAmount']?.valueChanges.subscribe(value => {
     if(this.userType=="I"){
      const amount = Number(value);
      const qty = Number(this.CONVERSION_RATE);
      this.returnAmount_Target_Convert = Number((amount / qty).toFixed(2));
     }
  });

  }
  GetIstGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-001', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }
  ChangeValue(data) {
    if (data == "No") {
      this.fundRequestForm.controls["CheckNumber"].setValue("");
    }
    else {
      this.fundRequestForm.controls["ReturnTransactionNumber"].setValue("");
    }
  }

  disable() {
    if (this.fundRequestForm.controls['Category'].value == null || this.fundRequestForm.controls['Category'].value == "") {
      this.fundRequestForm.controls['SubCategory'].disable();
    } else {
      if (this.Content.heading != 'View' && this.StatusStr == "Draft") {
        this.fundRequestForm.controls['SubCategory'].enable();
      }
    }
  }

  getFundEdit() {
    this.summaryService.masterData("api/ISTAllRequests/FundEdit?RecordID=" + this.Content.content.id + "&ApplicationID=" + this.ApplicationID).subscribe((result) => {
      if (this.AllsubCategoryOptions.length > 0) {
        this.CategoryChange(result["Category"]);
      }
      this.StatusStr = result["StatusStr"];
      this.RetrivalLabel = result["RetrivalLabel"];
      // this.currency = result["Currency"];
      this.fundRequestForm.patchValue(result);
      this.fundRequestForm.controls['ReturnAmount'].setValue(this.returnAmount);
      if (result["Status"] > 1) {
        this.PermissionAttach = "View";
      }
      else {
        this.PermissionAttach = this.Content.heading;
      }
      if (result["BankDetailsID"] != null && result["BankDetailsID"] != undefined) {
        this.BankChange(result["BankDetailsID"]);
      }
      if (this.Content.heading === 'View') { //View mode
        this.fundRequestForm.disable();
      }
      else {
        this.disabledControls(result["Status"], result);
      }

      if (this.Content.heading == 'Return') {
        this.fundRequestForm.controls['UsedFund'].disable();
        this.fundRequestForm.controls['ReturnAmount'].disable();
      }

      this.rowData = result["Attachments"];
      this.loadGrid = false;
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
       this.CONVERSION_RATE = result["CONVERSION_RATE"];
      if (this.userType == "E") {
        if (result["Status"] >= 2) {
          this.RequestedAmount_Target_Convert = parseFloat((parseFloat(result['RequiredFoud']) / result["CONVERSION_RATE"]).toFixed(2));
          if (result['AllocatedFund']) {
            this.AllocatedAmount_Target_Convert = parseFloat((parseFloat(result['AllocatedFund']) / result["CONVERSION_RATE"]).toFixed(2));
          }
          if (this.fundRequestForm.controls['ReturnAmount'].value) {
            this.returnAmount_Target_Convert = parseFloat((parseFloat( this.fundRequestForm.controls['ReturnAmount'].value) / result["CONVERSION_RATE"]).toFixed(2));
          }
          if (result['UsedFund']) {
            this.consumedAmount_Target_Convert = parseFloat((parseFloat(result['UsedFund']) / result["CONVERSION_RATE"]).toFixed(2));
          }
        
        }
      }
      else {
        this.RequestedAmount_Target_Convert = parseFloat((parseFloat(result['RequiredFoud']) * result["CONVERSION_RATE"]).toFixed(2));
        if (result['AllocatedFund']) {
          this.AllocatedAmount_Target_Convert = parseFloat((parseFloat(result['AllocatedFund']) * result["CONVERSION_RATE"]).toFixed(2));
        }
        if (this.fundRequestForm.controls['ReturnAmount'].value) {
          this.returnAmount_Target_Convert = parseFloat((parseFloat(this.fundRequestForm.controls['ReturnAmount'].value) * result["CONVERSION_RATE"]).toFixed(2));
        }
        if (result['UsedFund']) {
          this.consumedAmount_Target_Convert = parseFloat((parseFloat(result['UsedFund']) * result["CONVERSION_RATE"]).toFixed(2));
        }
      }
      this.extendedForm.rowid = result["ID"];
      this.extendedForm.getResponse();
    });
  }

  getMasterData() {
    this.summaryService.getSummaryData("api/ISTAllRequests/GetFundMasterDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id + "&CurrencyID=" + this.Currency_ID).subscribe(result => {
      this.bankDetailsOptions = result["MasterData1"];
      this.categoryOptions = result["MasterData2"];
      this.categoryOptions = [{ label: "Select", value: "", checked: true }].concat(this.categoryOptions);
      this.AllsubCategoryOptions = result["MasterData3"];
      if (result["AppCurrencyDropdown"] != null && result["AppCurrencyDropdown"] != undefined) {
        this.currency = result["AppCurrencyDropdown"].appCurrency_Symbol;
        this.currencyCode = result["AppCurrencyDropdown"].appCurrency_CODE;
        this.orgCurrency = result["AppCurrencyDropdown"].orgCurrency_CODE;
        this.orgSymbol = result["AppCurrencyDropdown"].orgCurrency_Symbol;
        if (this.userType == "E") {
          this.Currenct_Currency_Symbol = (this.currency);
          this.Target_Currency_Symbol = (this.orgSymbol);
        }
        else {
          this.Currenct_Currency_Symbol = (this.orgSymbol);
          this.Target_Currency_Symbol = (this.currency);
        }
      }

      if (this.Content.heading === 'Edit' || this.Content.heading === 'View' || this.Content.heading == 'Allocate') {
        this.CategoryChange(this.fundRequestForm.controls["Category"].value);
      }
    });
  }

  disabledControls(status: any, result: any) {

    if (status == 5) {
      this.fundRequestForm.controls["SubCategory"].disable();
      this.fundRequestForm.controls["OtherCattegory"].disable();
      this.fundRequestForm.controls["RequiredFoud"].disable();
      this.fundRequestForm.controls["Category"].disable();
    }
    else if (status == 7 || status == 4 || status == 8) {
      this.fundRequestForm.disable();
      this.Content.heading = "View";
    }
    else if (status > 1) {
      this.fundRequestForm.controls["SubCategory"].disable();
      this.fundRequestForm.controls["OtherCattegory"].disable();
      this.fundRequestForm.controls["RequiredFoud"].disable();
      this.fundRequestForm.controls["Category"].disable();
    }

    if (result["ReturnTransactionNumber"] != undefined && result["ReturnTransactionNumber"] != null) {

    }
    else {

    }

    if (this.userType == "E") {
      this.fundRequestForm.controls["AllocatedFund"].disable();
      this.fundRequestForm.controls["TransactionNumber"].disable();
    }
    document.body.click();
  }

  CategoryChange(data1) {
    this.subCategoryOptions = [];
    var data = this.AllsubCategoryOptions.filter(x => x.Parentvalue == data1);
    this.subCategoryOptions = data;
    this.subCategoryOptions = [{ label: "Select", value: "", checked: true }].concat(this.subCategoryOptions);
    this.disable();
  }

  BankChange(data1) {
    try {
      var data = this.bankDetailsOptions.filter(x => x.value == data1)[0];
      var addressList = [];
      if (data != null && data != undefined) {
        addressList = data.label.split(",");
      }
      this.billingAddress = new Object();
      this.billingAddress["FirstName"] = "";
      this.billingAddress["LastName"] = "";
      this.billingAddress["BankName"] = "";
      this.billingAddress["BankNumer"] = "";
      this.billingAddress["AccountNumber"] = "";
      this.billingAddress["Location"] = "";
      if (addressList.length > 0) {
        this.billingAddress["FirstName"] = addressList[0];
        this.billingAddress["LastName"] = addressList[1];
        this.billingAddress["BankName"] = addressList[2];
        this.billingAddress["BankNumer"] = addressList[3];
        this.billingAddress["AccountNumber"] = addressList[4];
        this.billingAddress["Location"] = addressList[5];
      }
    }
    catch (ex) { }
  }

  fundRetrivalRequestModal() {
    const modelRef = this['self'].modalService.open(FundReturnRetrivalModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content = {
      heading: null,
      content: null
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.fundRequestForm.value;

    //Category
    if (this.staticformFields?.CATEGORY_ID.IS_Display) {
      if ((formData.Category === null || formData.Category === "") && this.staticformFields?.CATEGORY_ID.IS_MANDATORY) {
        $("#Category").addClass("ng-touched ng-invalid validate-error");
        $("#Category").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.CATEGORY_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#Category").addClass("ng-untouched ng-valid");
        $("#Category").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //SubCategory
    if (this.staticformFields?.SUB_CATEGORY_ID.IS_Display) {
      if ((formData.SubCategory === null || formData.SubCategory === "") && this.staticformFields?.SUB_CATEGORY_ID.IS_MANDATORY) {
        $("#SubCategory").addClass("ng-touched ng-invalid validate-error");
        $("#SubCategory").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.SUB_CATEGORY_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#SubCategory").addClass("ng-untouched ng-valid");
        $("#SubCategory").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //RequiredFund
    formData.RequiredFoud = $("#RequiredFoud").val();
    if (this.staticformFields?.REQUIRED_FUND.IS_Display) {
      if ((formData.RequiredFoud === null || formData.RequiredFoud === "" || formData.RequiredFoud === undefined)
        && this.staticformFields?.REQUIRED_FUND.IS_MANDATORY) {
        $("#RequiredFoud").addClass("ng-touched ng-invalid validate-error");
        $("#RequiredFoud").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUIRED_FUND.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        const phoneformat = /^[1-9]\d*(\.\d+)?$/;
        formData.RequiredFoud = formData.RequiredFoud + "";
        if (formData.RequiredFoud.match(phoneformat)) {
          $("#RequiredFoud").addClass("ng-untouched ng-valid");
          $("#RequiredFoud").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#RequiredFoud").addClass("ng-touched ng-invalid validate-error");
          $("#RequiredFoud").removeClass("ng-untouched ng-valid");
          message += `Please enter Valid ${this.staticformFields?.REQUIRED_FUND.LABEL_NAME}<br/>`;
          isValid = false;
        }
      }
    }

    //AllocatedFund
    formData.AllocatedFund = $("#AllocatedFund").val();
    if (this.staticformFields?.ALLOCATED_FUND.IS_Display) {
      if ((formData.AllocatedFund === null || formData.AllocatedFund === "" || formData.AllocatedFund === undefined)
        && this.staticformFields?.ALLOCATED_FUND.IS_MANDATORY && formData['Status'] == 3) {
        $("#AllocatedFund").addClass("ng-touched ng-invalid validate-error");
        $("#AllocatedFund").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ALLOCATED_FUND.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#AllocatedFund").addClass("ng-untouched ng-valid");
        $("#AllocatedFund").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //AllocatedFund & RequiredFund
    formData.AllocatedFund = $("#AllocatedFund").val();
    if (this.staticformFields?.ALLOCATED_FUND.IS_Display) {
      if (formData.AllocatedFund !== null && formData.AllocatedFund !== "" && formData.AllocatedFund !== undefined) {
        const phoneformat = /^[1-9]\d*(\.\d+)?$/;
        formData.AllocatedFund = formData.AllocatedFund + "";

        if (formData.AllocatedFund.match(phoneformat)) {
          $("#AllocatedFund").addClass("ng-untouched ng-valid");
          $("#AllocatedFund").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#AllocatedFund").addClass("ng-touched ng-invalid validate-error");
          $("#AllocatedFund").removeClass("ng-untouched ng-valid");
          message += `Please enter valid ${this.staticformFields?.ALLOCATED_FUND.LABEL_NAME}<br/>`;
          isValid = false;
        }

        var quantity = this.fundRequestForm.controls["RequiredFoud"].value;
        if (quantity != null && quantity != undefined && this.staticformFields?.REQUIRED_FUND.IS_Display) {
          var Reqquantity1 = parseFloat(quantity);
          var Allquantity1 = parseFloat(formData.AllocatedFund);
          if (Allquantity1 > Reqquantity1) {
            $("#AllocatedFund").addClass("ng-touched ng-invalid validate-error");
            $("#AllocatedFund").removeClass("ng-untouched ng-valid");
            message += `${this.staticformFields?.ALLOCATED_FUND.LABEL_NAME} should not be greater than ${this.staticformFields?.REQUIRED_FUND.LABEL_NAME}<br/>`;
            isValid = false;
          }
        }
      }
    }

    //Transaction Number
    formData.TransactionNumber = $("#TransactionNumber").val();
    if (formData['Status'] > 2 && this.staticformFields?.TRANSACTION_NO.IS_Display && this.staticformFields?.TRANSACTION_NO.IS_MANDATORY && this.userType != 'E') {
      if ((formData.TransactionNumber === null || formData.TransactionNumber === ""
        || formData.TransactionNumber === undefined) && this.staticformFields?.TRANSACTION_NO.IS_MANDATORY) {
        $("#TransactionNumber").addClass("ng-touched ng-invalid validate-error");
        $("#TransactionNumber").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TRANSACTION_NO.LABEL_NAME}<br/>`;
        isValid = false;
      } else if (formData.TransactionNumber != null && formData.TransactionNumber != undefined && formData.TransactionNumber.trim() == "") {
        $("#TransactionNumber").addClass("ng-touched ng-invalid validate-error");
        $("#TransactionNumber").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TRANSACTION_NO.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#TransactionNumber").addClass("ng-untouched ng-valid");
        $("#TransactionNumber").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //UsedFund
    formData.UsedFund = $("#UsedFund").val();
    if (this.staticformFields?.USED_FUND.IS_Display) {
      if ((formData.UsedFund === null || formData.UsedFund === "" || formData.UsedFund === undefined)
        && this.staticformFields?.USED_FUND.IS_MANDATORY && formData['Status'] == 5) {
        $("#UsedFund").addClass("ng-touched ng-invalid validate-error");
        $("#UsedFund").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.USED_FUND.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#UsedFund").addClass("ng-untouched ng-valid");
        $("#UsedFund").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //UsedFund & AllocatedFund
    if (this.staticformFields?.USED_FUND.IS_Display && this.staticformFields?.ALLOCATED_FUND.IS_Display) {
      if (formData.UsedFund !== null && formData.UsedFund !== "" && formData.UsedFund !== undefined
        && formData.AllocatedFund !== null && formData.AllocatedFund !== "" && formData.AllocatedFund !== undefined) {

        var allocatedFund = parseFloat(formData.AllocatedFund);
        var usedFund = parseFloat(formData.UsedFund);
        if (usedFund > allocatedFund) {
          $("#UsedFund").addClass("ng-touched ng-invalid validate-error");
          $("#UsedFund").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields?.USED_FUND.LABEL_NAME} should not be greater than ${this.staticformFields?.ALLOCATED_FUND.LABEL_NAME}<br/>`;
          isValid = false;
        }
      }
    }

    //ReturnAmount
    // formData.ReturnAmount = $("#ReturnAmount").val();
    // if (this.staticformFields?.RETURN_AMOUNT.IS_Display) {
    //   if ((formData.ReturnAmount === null || formData.ReturnAmount === "" || formData.ReturnAmount === undefined)
    //     && this.staticformFields?.RETURN_AMOUNT.IS_MANDATORY) {
    //     $("#ReturnAmount").addClass("ng-touched ng-invalid validate-error");
    //     $("#ReturnAmount").removeClass("ng-untouched ng-valid");
    //     message += `Please enter ${this.staticformFields?.RETURN_AMOUNT.LABEL_NAME}<br/>`;
    //     isValid = false;
    //   } else {
    //     $("#ReturnAmount").addClass("ng-untouched ng-valid");
    //     $("#ReturnAmount").removeClass("ng-touched ng-invalid validate-error");
    //   }
    // }

    //Cheque ID
    if (this.returnVia === 'Cheque' && this.staticformFields?.CHEQUE_ID.IS_Display) {
      if ((formData.CheckNumber === null || formData.CheckNumber === "" || formData.CheckNumber === undefined)
        && this.staticformFields?.CHEQUE_ID.IS_MANDATORY) {
        $("#CheckNumber").addClass("ng-touched ng-invalid validate-error");
        $("#CheckNumber").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.CHEQUE_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else if (formData.CheckNumber != null && formData.CheckNumber != undefined && formData.CheckNumber.trim() == "") {
        $("#CheckNumber").addClass("ng-touched ng-invalid validate-error");
        $("#CheckNumber").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.CHEQUE_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#CheckNumber").addClass("ng-untouched ng-valid");
        $("#CheckNumber").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //Transaction ID
    formData.ReturnTransactionNumber = $("#ReturnTransactionNumber").val();
    if (this.returnVia === 'BankAccount' && this.staticformFields?.TRANSACTION_ID.IS_Display) {
      if ((formData.ReturnTransactionNumber === null || formData.ReturnTransactionNumber === ""
        || formData.ReturnTransactionNumber === undefined) && this.staticformFields?.TRANSACTION_ID.IS_MANDATORY) {
        $("#ReturnTransactionNumber").addClass("ng-touched ng-invalid validate-error");
        $("#ReturnTransactionNumber").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TRANSACTION_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else if (formData.ReturnTransactionNumber != null && formData.ReturnTransactionNumber != undefined && formData.ReturnTransactionNumber.trim() == "") {
        $("#ReturnTransactionNumber").addClass("ng-touched ng-invalid validate-error");
        $("#ReturnTransactionNumber").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TRANSACTION_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ReturnTransactionNumber").addClass("ng-untouched ng-valid");
        $("#ReturnTransactionNumber").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      message = message + ExtenMsgs; //this.extendedForm.validateControlsMsgs();
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }
  SaveIST_GI_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
    uploadData.append("Appid", '');
    uploadData.append("Application_Type_ID", this.Application_Type_ID);
    uploadData.append("Currency_ID", this.Currency_ID);

    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData);
  }
  saveFund() {
    if (this.validateControls()) {
      var formData = this.fundRequestForm.value;

      if (formData["RequiredFoud"] != null && formData["RequiredFoud"] != undefined) {
        formData["RequiredFoud"] = parseInt(formData["RequiredFoud"]);
      }

      if (formData["UsedFund"] == null && formData["UsedFund"] == undefined && formData["Status"] > 4) {
        formData["UsedFund"] = 0;
      }

      if (formData["UsedFund"] != null && formData["UsedFund"] != undefined) {
        formData["UsedFund"] = parseInt(formData["UsedFund"]);
      }

      if (formData["AllocatedFund"] != null && formData["AllocatedFund"] != undefined) {
        formData["AllocatedFund"] = parseInt(formData["AllocatedFund"]);
      }

      formData["TransactionNumber"] = this.fundRequestForm.controls["TransactionNumber"].value;
      formData["TransactionNumber"] = formData["TransactionNumber"] == null ? null : formData["TransactionNumber"] == undefined ? undefined : formData["TransactionNumber"].trim();
      formData["CheckNumber"] = this.fundRequestForm.controls["CheckNumber"].value;
      formData["CheckNumber"] = formData["CheckNumber"] == null ? null : formData["CheckNumber"] == undefined ? undefined : formData["CheckNumber"].trim();
      formData["ReturnTransactionNumber"] = this.fundRequestForm.controls["ReturnTransactionNumber"].value;
      formData["ReturnTransactionNumber"] = formData["ReturnTransactionNumber"] == null ? null : formData["ReturnTransactionNumber"] == undefined ? undefined : formData["ReturnTransactionNumber"].trim();

      formData["ReturnAmount"] = this.returnAmount;
      formData["Currency"] = this.currency;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;
      if (this.Content.heading === 'Add') {
        if (!this.ApplicationID) {
          this.SaveIST_GI_APP().subscribe((res) => {
            if (res.Status === 0) {
              this.ApplicationID = res["TransactionID"];
              this.datashareService.setApplicationID(this.ApplicationID);
              formData["Application_ID"] = this.ApplicationID;
              formData["ID"] = this.Content.content.id;
              this.summaryService.Insert("api/ISTAllRequests/InsertFund", formData).subscribe(result => {
                if (result.Status == 0) {
                  this.fundRequestForm.controls["ID"].setValue(result.TransactionID);
                  this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                    if (result1.Status == 0) {
                      this.commonService.SuccessBanner("Request Submitted successfully");
                      this.commonService.refreshPage(this.ApplicationID);
                      this.modalRef.close(result);
                    }
                    else {
                      this.commonService.ValidationBanner(result1.Message);
                    }
                  });
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              });
            }
          });
        }
        else {
          formData["Application_ID"] = this.ApplicationID;
          formData["ID"] = this.Content.content.id;
          this.summaryService.Insert("api/ISTAllRequests/InsertFund", formData).subscribe(result => {
            if (result.Status == 0) {
              this.fundRequestForm.controls["ID"].setValue(result.TransactionID);
              this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                if (result1.Status == 0) {
                  this.commonService.SuccessBanner("Request Submitted successfully");
                  this.modalRef.close(result);
                }
                else {
                  this.commonService.ValidationBanner(result1.Message);
                }
              });
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }


      } else if (this.Content.heading === 'Edit' || this.Content.heading === 'Allocate' || this.Content.heading === 'Return') {
        formData["Application_ID"] = this.ApplicationID;
        this.summaryService.Insert("api/ISTAllRequests/UpdateFund", formData).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES") {
            this.fundRequestForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") {
                if (result.Status == 0) {
                  if (this.Content.heading === 'Return') {
                    this.commonService.SuccessBanner("Return details shared successfully");
                  }
                  else {
                    this.commonService.SuccessBanner("Request details updated successfully");
                  }
                  this.modalRef.close(result);
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  if (this.Content.heading === 'Return') {
                    this.commonService.SuccessBanner("Return details shared successfully");
                  } else {
                    this.commonService.SuccessBanner("Request details updated successfully");
                  }
                  this.modalRef.close(result);
                }
              }
            });
          }
          else if (result.ErrorCode == "NOBUDGET") {
            this.commonService.ValidationBanner(result.Message);
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
    }
  }



  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {
    this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + 1).subscribe((result) => {
      this.rowData = result;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 350);
    });
  }

  addNewAttachment() {
    let modalRef = this.modalService.open(AttachmentClassificationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      screencode: "SCR-007",
      content: { id: "", ModuleName: "IST", ScreenName: 'FundRequest', filesList: this.rowData }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      result.forEach((item: any) => {
        this.rowData.push(item);
      });
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })

  }

  setOperations(RawData: any): any {
    RawData.forEach(element => {
      if ((element.Status == "Add" && this.Content.heading == 'Edit') ||
        element.FileID == null) {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      } else {

        let tempOperations;
        if (this.Content.heading == 'Edit') {
          tempOperations = [
            {
              "name": "Delete",
              "id": "Delete"
            },
            {
              "name": "Download",
              "id": "Download"
            }
            // ,
            // {
            //   "name": "Preview",
            //   "id": "ViewFile"
            // }
          ];
        }

        if (this.Content.heading == 'View') {
          tempOperations = [
            {
              "name": "Download",
              "id": "Download"
            }
            // ,
            // {
            //   "name": "Preview",
            //   "id": "ViewFile"
            // }
          ];
        }

        if (this.Content.heading == "Add") {

          tempOperations = [
            {
              "name": "Delete",
              "id": "Delete"
            }
          ];
        }



        if (this.commonService.isAllowedExtension(element.FileName) == true && this.Content.heading != "Add") {
          tempOperations.push(
            {
              "name": "Preview",
              "id": "ViewFile"
            }
          );
        }

        if (this.Content.heading == "Allocate") {

          tempOperations = [
          ];
        }
        element["Operations"] = this.setDef(tempOperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  Download() {
    var fileID = this['self'].selectedRow['FileID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.previewFile(fileID, fileName, "med");
  }

  Delete() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.CheckIsFileIsRefereancedInReviw(fileID).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
        modalRef.componentInstance.Content = {
          heading: '',
          custommessage: 'Are you sure you want to delete the ' + fileName + '?',
          ProceedButtonName: "Delete", TerminateButtonName: "Cancel"
        };
        modalRef.result.then(result => {
          if (result == 'okclick') {
            let index = this['self'].rowData.findIndex(x => x.FileID == fileID);
            if (index != null) {
              this['self'].rowData.splice(index, 1);
              this['self'].loadGrid = false;
              setTimeout(() => {
                this['self'].loadGrid = true;
                document.body.click();
              }, 300);
            }
          }
        });
      }
    });
  }
}
